/**
 * External dependencies
 */
import { reduce, get, omitBy,  values, forOwn } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
	{},
	{
		[actions.DASHBOARD_LAYOUTS_RECEIVE]: (state, action) => {
			return reduce(
				action.payload.dashboardLayouts,
				(memo, dashboardLayout) => {
					const { id } = dashboardLayout;
					if (memo === state) {
						memo = { ...memo };
					}
					memo[id] = dashboardLayout;
					return memo;
				},
				state,
			);
		},
		[actions.DELETE_DASHBOARD_LAYOUT_SUCCESS]: (state, action) => {
			const layoutId = get(action, ['payload', ['layoutId']]);
			const items = { ...state };
			return omitBy(items, { id: layoutId });
		},

		// Cant think of a better way to handle deletes without fetching the layouts
		// from the server
		// SO: just remove the deleted widget from any layouts
		// 
		// NOTE: the server will cascade remove these items from layouts
		[actions.DELETE_REPORT_SUCCESS]: (state, action) => {

			let c = {...state};
			const widgetId = get(action, ['payload', ['reportId']]);

			forOwn(state, (layout) => {
				layout.items = values(omitBy(layout.items, { widget: widgetId }));
			});

			return c;
		},
	},
);
